import { encode } from 'js-base64'
import { Assets, type Texture } from 'pixi.js'
import bgStartUrl from '../assets/images/bg/bgStart.png?url'
import bgRoadUrl from '../assets/images/bg/bgRoad.png?url'
import bgFinishUrl from '../assets/images/bg/bgFinish.png?url'
import springBoardUrl from '../assets/images/bg/decorations/springBoard.png?url'
import statuePhoneUrl from '../assets/images/bg/decorations/statuePhone.png?url'
import chickenStaticUrl from '../assets/images/chicken/chickenStatic.png?url'
import chickenRunOverUrl from '../assets/images/chicken/chickenRunOver.png?url'
import chickenScoreUrl from '../assets/images/chicken/chickenScore.png?url'
import coinBronzeUrl from '../assets/images/road/coinBronze.png?url'
import coinGoldUrl from '../assets/images/road/coinGold.png?url'
import fencingUrl from '../assets/images/road/fencing.png?url'
import car0Url from '../assets/images/road/cars/car_0.png?url'
import car1Url from '../assets/images/road/cars/car_1.png?url'
import car2Url from '../assets/images/road/cars/car_2.png?url'
import car3Url from '../assets/images/road/cars/car_3.png?url'
import winnerWindowUrl from '../assets/images/winnerWindow.png?url'
import chickenSpineJson from '../assets/animation/chiken.json?raw'
import chickenSpineAtlas from '../assets/animation/chiken.atlas?raw'
import chickenSpineImageUrl from '../assets/animation/chiken.png?url'

export class AssetManager {
	private static loaded = false

	static get isLoaded() {
		return this.loaded
	}

	static async loadAll(onProgress?: (progress: number) => void) {
		if (this.loaded) {
			onProgress?.(1)
			return
		}

		await Assets.load(
			[
				{ alias: 'bgStart', src: bgStartUrl },
				{ alias: 'bgRoad', src: bgRoadUrl },
				{ alias: 'bgFinish', src: bgFinishUrl },
				{ alias: 'springBoard', src: springBoardUrl },
				{ alias: 'statuePhone', src: statuePhoneUrl },
				{ alias: 'chickenStatic', src: chickenStaticUrl },
				{ alias: 'chickenRunOver', src: chickenRunOverUrl },
				{ alias: 'chickenScore', src: chickenScoreUrl },
				{ alias: 'coinBronze', src: coinBronzeUrl },
				{ alias: 'coinGold', src: coinGoldUrl },
				{ alias: 'fencing', src: fencingUrl },
				{ alias: 'car0', src: car0Url },
				{ alias: 'car1', src: car1Url },
				{ alias: 'car2', src: car2Url },
				{ alias: 'car3', src: car3Url },
				{ alias: 'winnerWindow', src: winnerWindowUrl },
				{ alias: 'chickenSpineImage', src: chickenSpineImageUrl },
			],
			(progress) => {
				onProgress?.(progress * 0.85)
			},
		)

		const chickenTexture = Assets.get<Texture>('chickenSpineImage')

		// Embed atlas/skeleton as data URLs so Spine parsers don't depend on
		// hashed file extensions (same approach as the reference chicken game).
		await Assets.load(
			[
				{
					alias: 'chickenSpine',
					parser: 'json',
					src: `data:application/json;base64,${encode(chickenSpineJson)}`,
				},
				{
					alias: 'chickenSpineAtlas',
					parser: 'spineTextureAtlasLoader',
					src: `data:text/plain;base64,${encode(chickenSpineAtlas)}`,
					data: {
						images: {
							'chiken.png': chickenTexture.source,
						},
					},
				},
			],
			(progress) => {
				onProgress?.(0.85 + progress * 0.15)
			},
		)

		this.loaded = true
		onProgress?.(1)
	}
}
